import React from "react";
import { Box, Typography, LinearProgress } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import { stepBarStyles } from './StepBar.styles';

interface StepBarProps {
  currentStep?: 1 | 2 | 3 | 4;
}

const STEP_PROGRESS_MAP: Record<number, number> = { 1: 7, 2: 58, 3: 100, 4: 100 };

export function StepBar({ currentStep = 1 }: StepBarProps) {
  const progressValue = STEP_PROGRESS_MAP[currentStep] ?? 0;

  const stepState = (stepNum: number): 'completed' | 'active' | 'pending' => {
    if (currentStep > stepNum) return 'completed';
    if (currentStep === stepNum) return 'active';
    return 'pending';
  };

  const StepItem = ({ num, label }: { num: number; label: string }) => {
    const state = stepState(num);
    return (
      <Box sx={stepBarStyles.stepItem}>
        {state === 'completed' && (
          <CheckCircleIcon sx={stepBarStyles.tickIcon} />
        )}
        <Typography sx={stepBarStyles.stepLabel(state)}>
          {label}
        </Typography>
      </Box>
    );
  };

  return (
    <Box sx={stepBarStyles.root}>
      <Box sx={stepBarStyles.stepsRow}>
        <StepItem num={1} label="PAN" />
        <Box sx={stepBarStyles.divider} />
        <StepItem num={2} label="Bank A/C" />
        <Box sx={stepBarStyles.divider} />
        <StepItem num={3} label="Submit" />
      </Box>
      <LinearProgress variant="determinate" value={progressValue} sx={stepBarStyles.progress} />
    </Box>
  );
}
